import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="lazy-image"
export default class extends Controller {
  connect() {
    const img = this.element.querySelector("img")

    if (img.complete) {
      this._loaded()
    } else {
      img.addEventListener("load", this._loaded.bind(this))
    }
  }

  _loaded() {
    this.element.classList.add("loaded")
  }
}
